export const getActionButtonData = (isUnpaidOrder, status, t) => {
	if (isUnpaidOrder) {
		return {
			icon: 'CASH',
			text: t('PickupMonitor.buttons.pay'),
			className: 'unpaid',
			updatableStatus: null,
		}
	} else if (status === 'AWAITING_PICKUP') {
		return {
			icon: 'arrow-right-thin',
			text: t('PickupMonitor.buttons.readyForPickup'),
			className: 'awaiting-pickup',
			updatableStatus: 'PROCESSING_PICKUP',
		}
	} else if (status === 'PROCESSING_PICKUP') {
		return {
			icon: 'recipient',
			text: t('PickupMonitor.buttons.pickedUp'),
			className: 'processing-pickup',
			updatableStatus: 'PICKED_UP',
		}
	}
}
